import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {fetchSchedules, saveSchedule} from './shifts-api';

export const SCHEDULES_KEY = ['operator-schedules'];

export const useSchedules = () =>
    useQuery({
        queryKey: SCHEDULES_KEY,
        queryFn: fetchSchedules,
        // Two roles edit these rows from two different screens. Refetching when the tab regains
        // focus is the cheap half of keeping them honest; the STOMP push is the other half.
        refetchOnWindowFocus: true,
    });

export const useSaveSchedule = (onSuccess) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({operatorId, workSchedule}) => saveSchedule(operatorId, workSchedule),
        onSuccess: (data) => {
            queryClient.invalidateQueries({queryKey: SCHEDULES_KEY});
            // The admin's operator screen shows the same rota under a different query key, so a
            // supervisor's save has to land there too — that screen is where an admin looks.
            queryClient.invalidateQueries({queryKey: ['operators']});
            onSuccess?.(data);
        },
    });
};
